import { AnalyticsActionTypes } from '@analytics/models';
import { Component, Input } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import type { InnogyComponentRendering } from '@core/jss-models';
import {
  JssModule,
  LinkField,
  TextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { TrackLinkDirective, TrackStepDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { GenericLinkDirective } from '@core/jss-utils';
import { CardComponent } from '@legacy/common-ui-partials';
import { DisableBodyScrollingClassDirective } from '@innogy/utils-dom';

import { ModalPageHeaderComponent } from '../modal-page-header/modal-page-header.component';

@Component({
  selector: 'wl-success-page',
  templateUrl: './success-page.component.html',
  standalone: true,
  imports: [
    TrackStepDirective,
    DisableBodyScrollingClassDirective,
    AutomationIdDirective,
    ModalPageHeaderComponent,
    FaIconComponent,
    JssModule,
    GenericLinkDirective,
    TrackLinkDirective,
    CardComponent,
  ],
})
export class SuccessPageComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public automationId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public successTitle?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public successMessage?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public successSubMessage?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public successLink?: LinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public backLink?: LinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public step = 1;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public navigationExtras: NavigationExtras = {};
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public trackLastStep = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public e2eTrackingId?: string | null;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showHeader = true;

  get extras(): NavigationExtras {
    return {
      queryParamsHandling: 'merge',
      queryParams: { returnUrl: null },
      ...this.navigationExtras,
    };
  }

  protected readonly AnalyticsActionTypes = AnalyticsActionTypes;
}
